"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AnyLinkRenderer = {
    renderV1(link, _fetch, options) {
        return {
            type: "Link.any",
            value: {
                ...(!(options === null || options === void 0 ? void 0 : options.omitKey) && { key: link.key }),
                ...(link.value.text && { text: link.value.text }),
                ...(link.value.variant && { variant: link.value.variant }),
            },
        };
    },
    renderV2(def, link, _fetch, options) {
        const defVariants = def.variants || [];
        const linkVariant = link.value.variant && defVariants.includes(link.value.variant) ? link.value.variant : defVariants[0];
        return {
            link_type: "Any",
            ...(!(options === null || options === void 0 ? void 0 : options.omitKey) && { key: link.key }),
            ...(def.allowText && link.value.text && { text: link.value.text }),
            ...(linkVariant && { variant: linkVariant }),
        };
    },
    renderMocks(def, link, options) {
        return this.renderV2(def, link, undefined, options);
    },
};
exports.default = AnyLinkRenderer;
